// src/PageViewTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logPageView } from "./analytics";

const PageViewTracker = () => {
    const location = useLocation();

    useEffect(() => {
        logPageView(location.pathname + location.search);
    }, [location]);

    return null; // This component doesn’t render anything
};

export default PageViewTracker;
